module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "picker-searchbox item multiple-lines bg-secondary"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(0), _vm._v(" "), _c('q-autocomplete', {
    attrs: {
      "min-characters": 2,
      "delay": 0,
      "delimiter": ""
    },
    on: {
      "search": _vm.search,
      "selected": _vm.selected
    },
    model: {
      value: (_vm.searchVal),
      callback: function($$v) {
        _vm.searchVal = $$v
      },
      expression: "searchVal"
    }
  }, [_c('q-search', {
    attrs: {
      "placeholder": "Find a school"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleDrawer($event)
      }
    },
    model: {
      value: (_vm.searchVal),
      callback: function($$v) {
        _vm.searchVal = $$v
      },
      expression: "searchVal"
    }
  })], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('small', {
    staticClass: "item-title text-black"
  }, [_vm._v("SEARCH")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b751e28e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b751e28e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FilterView/SearchBox.vue
// module id = 862
// module chunks = 0